if (!customElements.get('cg-sticky-atc')) {
  customElements.define(
    'cg-sticky-atc',
    class CGStickyATC extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        this.productInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`) || document.querySelector('product-info');
        this.sourceForm = document.querySelector(`#product-form-${this.sectionId}`) || document.querySelector('product-info form[id^="product-form-"]');
        this.stickyForm = this.querySelector('form');
        this.stickyVariantInput = this.stickyForm?.querySelector('input[name="id"]');
        this.submitButton = this.querySelector('.product-form__submit');
        this.rootObserver = null;
      }

      connectedCallback() {
        if (!this.sourceForm || !this.stickyForm || !this.stickyVariantInput) return;
        this.syncVariantId();
        this.syncButtonState();
        this.observeVisibility();
        this.bindEvents();
      }

      disconnectedCallback() {
        this.rootObserver?.disconnect();
        this.sourceForm?.removeEventListener('change', this.onSourceFormChange);
        document.removeEventListener('change', this.onDocumentChange, true);
        this.productInfo?.removeEventListener('variant-change', this.onVariantEvent);
      }

      bindEvents() {
        this.onSourceFormChange = () => {
          this.syncVariantId();
          this.syncButtonState();
        };

        this.onDocumentChange = (event) => {
          if (!this.sourceForm) return;
          if (this.sourceForm.contains(event.target)) {
            window.requestAnimationFrame(() => {
              this.syncVariantId();
              this.syncButtonState();
            });
          }
        };

        this.onVariantEvent = () => {
          window.requestAnimationFrame(() => {
            this.syncVariantId();
            this.syncButtonState();
          });
        };

        this.sourceForm.addEventListener('change', this.onSourceFormChange);
        document.addEventListener('change', this.onDocumentChange, true);
        this.productInfo?.addEventListener('variant-change', this.onVariantEvent);
      }

      observeVisibility() {
        const watchTarget = this.sourceForm.closest('.product-form__buttons') || this.sourceForm;
        this.rootObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.remove('is-visible');
              } else {
                this.classList.add('is-visible');
              }
            });
          },
          {
            threshold: 0.15,
          }
        );
        this.rootObserver.observe(watchTarget);
      }

      syncVariantId() {
        const sourceInput = this.sourceForm?.querySelector('input[name="id"]');
        if (!sourceInput) return;
        this.stickyVariantInput.value = sourceInput.value;
      }

      syncButtonState() {
        const sourceSubmit = this.sourceForm?.querySelector('[name="add"], .product-form__submit');
        if (!sourceSubmit || !this.submitButton) return;

        const disabled = sourceSubmit.hasAttribute('disabled') || sourceSubmit.getAttribute('aria-disabled') === 'true';
        this.submitButton.toggleAttribute('disabled', disabled);
        this.submitButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
    }
  );
}
